import { Link } from "react-router-dom";
import { PageMeta } from "@/components/shared";

export default function NotFound() {
  return (
    <>
      <PageMeta title="Page not found | SafetySymbiosis" noindex />

      <section className="border-b border-brand-line bg-white py-14 lg:py-20">
        <div className="wrap">
          <span className="eyebrow">404</span>
          <h1 className="mt-5 max-w-3xl font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-charcoal/85 sm:text-lg">
            The page you are looking for does not exist or may have been moved.
            Return to the homepage or get in touch if you need HSE support.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/" className="btn-navy" data-testid="not-found-home-link">
              Back to Home
            </Link>
            <Link to="/contact" className="btn-outline" data-testid="not-found-contact-link">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
